module.exports = __webpack_public_path__ + "img/interface.736de58b.webp";